// The API should always be called using the defined endpoints below.
export enum ApiEndpoints {
  Ping = "ping",
  Activities = "activities",
  ActivitiesCurrent = `${Activities}/current`,
  ActivitiesCurrentArchived = `${ActivitiesCurrent}/archived`,
  ActivityDrafts = `${Activities}/drafts`,
  ActivityDraftsSaveAndPublish = `${ActivityDrafts}/saveandpublish`,
  ActivityFields = `${Activities}/fields`,
  ActivityQuickEditFields = `${ActivityFields}/quickedit`,
  ActivityPublish = `${Activities}/publish`,
  ActivityMassPublish = `${Activities}/masspublish`,
  ActivityMassCreateDraft = `${Activities}/masscreatedraft`,
  ActivityFullHistory = `${Activities}/fullhistory`,
  ActivityActivate = `${Activities}/activate`,
  ActivityUsedPaths = `${Activities}/usedpaths`,
  ActivityFilters = `${Activities}/filters`,
  CollectionTitles = "collectionTitles",
  Chapters = "chapters",
  Tags = "tags",
  TagsUpdate = `${Tags}/update`,
  TagsSort = `${Tags}/sort`,
  TagsRearrange = `${Tags}/rearrange`,
  TagsCopy = `${Tags}/copy`,
  TagsImport = `${Tags}/import`,
  Navigation = "navigation",
  TagCollections = "tagCollections",
  Image = "image",
  ImageChapters = `${Image}/chapters`,
  ImageDrafts = `${Image}/drafts`,
  ImageDraftsQuickEdit = `${ImageDrafts}/quickedit`,
  ImageDraftsClone = `${ImageDrafts}/clone`,
  ImageDraftsSaveAndPublish = `${ImageDrafts}/saveandpublish`,
  ImageMassCreateDraft = `${ImageDrafts}/masscreatedraft`,
  ImageMassPublish = `${Image}/masspublish`,
  ImageCurrent = `${Image}/current`,
  ImageCurrentArchived = `${ImageCurrent}/archived`,
  ImagePublished = `${Image}/publish`,
  ImageHistory = `${Image}/history`,
  ImageFullHistory = `${Image}/fullhistory`,
  ImageFields = `${Image}/fields`,
  ImageQuickEditFields = `${ImageFields}/quickedit`,
  ImageActivityNames = `${Image}/activitynames`,
  ImageChapterNames = `${Image}/chapternames`,
  ImageFilters = `${Image}/filters`,
  PublishedMediaMetadataMigrations = `${Image}/admin/published-media-metadata-migrations`,
  ImageFileMigrations = `${Image}/admin/image-file-migrations`,
  ImageMetadataUpdater = `${Image}/admin/image-metadata-updater`,
  ReportsDraftActivities = "reports/activities/draft",
  ReportsDraftDocuments = "reports/documents/draft",
  ReportsDraftLinks = "reports/links/draft",
  ReportsDraftActivityImages = "reports/activityimages/draft",
  ReportsPublishedActivities = "reports/activities/published",
  ReportsPublishedDocuments = "reports/documents/published",
  ReportsDocumentsWithLinks = "reports/documents/links",
  ReportsPublishedLinks = "reports/links/published",
  ReportsPublishedActivityImages = "reports/activityimages/published",
  Tools = "tools",
  ToolDrafts = `${Tools}/drafts`,
  ToolDraftsSaveAndPublish = `${ToolDrafts}/saveandpublish`,
  ToolDraftsQuickEdit = `${Tools}/drafts/quickedit`,
  ToolDocumentDrafts = `${ToolDrafts}/documents`,
  ToolDownload = `${Tools}/download`,
  ToolOriginalDownload = `${ToolDownload}/original`,
  ToolDraftDownload = `${ToolDownload}/draft`,
  ToolOriginalDownloads = `${ToolDownload}/originals`,
  ToolLinkDrafts = `${ToolDrafts}/links`,
  ToolPublished = `${Tools}/publish`,
  ToolMassCreateDraft = `${Tools}/masscreatedraft`,
  ToolsCurrent = `${Tools}/current`,
  ToolDocumentsCurrent = `${Tools}/current/documents`,
  ToolLinksCurrent = `${Tools}/current/links`,
  ToolLinksCurrentArchived = `${ToolLinksCurrent}/archived`,
  ToolsCurrentBatch = `${Tools}/current/batch`,
  ToolHistory = `${Tools}/history`,
  ToolOldVersion = `${Tools}/history/versions`,
  ToolFullHistory = `${Tools}/fullhistory`,
  ToolLinkFields = `${Tools}/linkfields`,
  ToolDocumentFields = `${Tools}/documentfields`,
  ToolLinkQuickEditFields = `${ToolLinkFields}/quickedit`,
  ToolDocumentQuickEditFields = `${ToolDocumentFields}/quickedit`,
  ToolDraftClone = `${ToolDrafts}/clone`,
  ToolDraftValidateFile = `${ToolDrafts}/validatefile`,
  ToolActivate = `${Tools}/activate`,
  ToolDocumentNames = `${Tools}/documentnames`,
  ToolDocumentFilters = `${Tools}/filters/documents`,
  ToolLinkFilters = `${Tools}/filters/links`,
  ToolAdminDelete = `${Tools}/admin`,
  ToolAdminSearchDocuments = `${Tools}/admin/search/documents`,
  ToolAdminSearchLinks = `${Tools}/admin/search/links`,
  ToolAdminValidateFile = `${Tools}/admin/validate/file`,
  ToolAdminHealthCheckStatus = `${Tools}/admin/health-check/status`,
  ToolAdminHealthCheckStart = `${Tools}/admin/health-check/start`,
  PublishedDocumentMetadataMigrations = `${Tools}/admin/published-document-metadata-migrations`,
  ToolAdminRelink = `${Tools}/admin`,
  DocumentGridView = "DocumentGridView",
  DocumentGridViewCurrent = `${DocumentGridView}/current`,
  DocumentGridViewArchived = `${DocumentGridViewCurrent}/archived`,
  DocumentGridViewDrafts = `${DocumentGridView}/drafts`,
  Files = "files",
  Users = "users",
  UsersMe = `${Users}/me`,
  EntraGroupMemberships = "EntraGroupMemberships",
  EntraGroupMembershipUsers = `${EntraGroupMemberships}/users`,
  EntraGroupMembershipMembers = `${EntraGroupMemberships}/members`,
  ReindexAll = "Index/ReindexAll",
  ReindexJobStatus = "Index/ReindexStatus",
  ReindexJobHistory = "Index/JobHistory",
  ReindexJobHistoryById = "Index/JobHistory/id",
  CancelJob = "Index/CancelJob",
  Cache = "cache",
  CacheNavigation = "cache/navigation",
  Roles = "roles",
  RolesUpdate = `${Roles}/update`,
  RolesPerson = `${Roles}/person`,
  SearchFilters = "search/filters",
  SearchFiltersGlobal = `${SearchFilters}/global/configuration`,
  SearchFiltersFields = `${SearchFilters}/fields`,
  UserLibraryFilters = "UserLibraryFilters",
  UserLibraryFiltersState = `${UserLibraryFilters}/state`,
  UtilityLinks = "utilitylinks",
  SystemInfoBanner = "systeminfobanner",
  SystemInfoBannerCurrent = `${SystemInfoBanner}/current`,
}
